import type {Content} from '@prismicio/client'
import type {SliceComponentProps} from '@prismicio/react'
import {DefaultComparisonSection} from './DefaultComparisonSection'
import {RefreshComparisonSection} from './RefreshComparisonSection'

/**
 * Props for `ComparisonSection`.
 */
export type ComparisonSectionProps = SliceComponentProps<Content.ComparisonSectionSlice>

/**
 * Component for "ComparisonSection" Slices.
 */
const ComparisonSection = ({slice}: ComparisonSectionProps): JSX.Element => {
  switch (slice.variation) {
    case 'refresh':
      return <RefreshComparisonSection slice={slice} />
    default:
      return <DefaultComparisonSection slice={slice} />
  }
}

export default ComparisonSection
